/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Deep_P2Inputs */

const en_sorter_deep_p2 = /** @type {(inputs: Sorter_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accented and non Latin characters show the difference more sharply. The key école has a code point above z, so byte order would place it after zebra. Locale collation treats it as an e and places it first. If you are producing a canonical form that a program on another platform has to reproduce byte for byte, locale collation is the wrong tool, because the result depends on the collation tables of the environment that produced it.`)
};

const ko_sorter_deep_p2 = /** @type {(inputs: Sorter_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`악센트 문자와 비라틴 문자에서 차이가 더 뚜렷해집니다. école이라는 키는 코드 포인트가 z보다 크므로 바이트 순이라면 zebra 뒤에 놓입니다. 로케일 정렬은 이를 e로 취급해 앞에 둡니다. 다른 플랫폼의 프로그램이 바이트 단위로 재현해야 하는 정규형을 만들고 있다면 로케일 정렬은 잘못된 도구입니다. 결과가 그것을 만든 환경의 정렬 테이블에 의존하기 때문입니다.`)
};

const ja_sorter_deep_p2 = /** @type {(inputs: Sorter_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクセント付き文字や非ラテン文字で違いがより鮮明になります。école というキーはコードポイントが z より大きいので、バイト順なら zebra の後に置かれます。ロケール照合はこれを e として扱い前に置きます。別のプラットフォームのプログラムがバイト単位で再現しなければならない正規形を作っているなら、ロケール照合は誤った道具です。結果がそれを作った環境の照合テーブルに依存するからです。`)
};

/**
* | output |
* | --- |
* | "Accented and non Latin characters show the difference more sharply. The key école has a code point above z, so byte order would place it after zebra. Locale ..." |
*
* @param {Sorter_Deep_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_deep_p2 = /** @type {((inputs?: Sorter_Deep_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Deep_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_deep_p2(inputs)
	if (locale === "ko") return ko_sorter_deep_p2(inputs)
	return ja_sorter_deep_p2(inputs)
});